import { render, staticRenderFns } from "./TimelineBasic.vue?vue&type=template&id=875ad40c"
import script from "./TimelineBasic.vue?vue&type=script&lang=js"
export * from "./TimelineBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports